module.exports = __webpack_public_path__ + "static/media/Bluetooth.6109cda5.png";